import {types} from '../../types';

const setGetPresentListAction = (payload) => {
    return {
        type: types.common.SET_GET_PRESENT,
        payload,
      }
}


export {
  setGetPresentListAction as SetGetPresentListAction,
}